import React from "react";
import Text from "@/bit/components/components.text";
import Button from "@/bit/components/components.button";
import Label from "@/bit/components/components.cms-block.cms-label";
import Price from "@/bit/components/components.price";
import CmsClickToCall from "@/bit/components/components.cms-block.cms-click-to-call";
import CustomLink from "@/bit/components/components.custom-link";

const BUYBOX_TAGGING_INFO = {
  componentName: "BuyBox",
  componentVariation: "all",
};

const hasTextContent = (textProps) =>
  !!textProps && textProps.text && typeof textProps.text === "string";

const hasPriceContent = (priceProps) =>
  !!priceProps &&
  (typeof priceProps.price === "number" ||
    typeof priceProps.price === "string") &&
  typeof priceProps.currency === "string";

/**
 * Componente que permite crear un item de buybox
 */
function CmsBuybox(props) {
  const {
    cmsHandler,
    showSeparator,
    alias,
    blockName,
    index,
    frontalListToDelete,
    CmsEditableGroupIcons,
    className = "",
  } = props;

  const buyBoxButton1 = props["cms-atom-button-1"];
  const buyBoxButton2 = props["cms-atom-button-2"];
  const buyBoxLabel1 = props["cms-atom-label-1"];
  const buyBoxLabel2 = props["cms-atom-label-2"];
  const buyBoxPrice1 = props["cms-atom-price-1"];
  const buyBoxPrice2 = props["cms-atom-price-2"];
  const buyBoxText1 = props["cms-atom-text-1"];
  const buyBoxText2 = props["cms-atom-text-2"];
  const buyBoxText3 = props["cms-atom-text-3"];
  const buyBoxC2C = props["cms-component-click-to-call-1"];
  const hiringDetails = props["cms-hiring-details-1"];

  // LEGALES
  const legalesLink1 = props["cms-atom-link-1"];
  const legalesText1 = props["cms-atom-text-4"];
  const legalesText2 = props["cms-atom-text-5"];
  const hasLegalesText1 = hasTextContent(legalesText1);
  const hasLegalesText2 = hasTextContent(legalesText2);

  const taggingLink1 = {
    ...BUYBOX_TAGGING_INFO,
    componentContent: legalesLink1?.label || "Legales",
    ...legalesLink1?.taggingInfo,
  };

  const taggingButton1 = {
    ...BUYBOX_TAGGING_INFO,
    componentContent: buyBoxButton1?.label || "Contratar",
    ...buyBoxButton1?.taggingInfo,
  };

  const taggingButton2 = {
    ...BUYBOX_TAGGING_INFO,
    componentContent: buyBoxButton2?.label || "Contratar",
    ...buyBoxButton2?.taggingInfo,
  };

  const finalClassName = [
    "buybox-info",
    cmsHandler && "relative-element",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      <div className={finalClassName}>
        {/* Bolitas de edicion aqui */}
        {CmsEditableGroupIcons && (
          <CmsEditableGroupIcons
            elementProps={{
              ...props,
              hiringDetails,
              editName: "cms-block.cms-buy-box",
            }}
            deleteProps={{
              index,
              itemIdDotNotation: `${blockName}.cms-ml-buy-box-1.cms-ml-buy-box-list`,
              alias,
              frontalListToDelete,
            }}
            visibleTools={{
              hiring: true,
              edit: false,
              deleteItem: true,
            }}
            noCustomLink
            cmsHandler={cmsHandler}
          />
        )}
        <div className="info-price">
          {hasTextContent(buyBoxText1) && (
            <Text {...buyBoxText1} cmsHandler={cmsHandler} />
          )}
          {buyBoxLabel2 && <Label {...buyBoxLabel2} cmsHandler={cmsHandler} />}
          {buyBoxLabel1 && <Label {...buyBoxLabel1} cmsHandler={cmsHandler} />}
          {hasTextContent(buyBoxText2) && (
            <Text {...buyBoxText2} cmsHandler={cmsHandler} />
          )}
          <div className="content-price">
            {hasPriceContent(buyBoxPrice2) && (
              <Price {...buyBoxPrice2} cmsHandler={cmsHandler} />
            )}
            {hasPriceContent(buyBoxPrice1) && (
              <Price {...buyBoxPrice1} cmsHandler={cmsHandler} />
            )}
          </div>
          {hasTextContent(buyBoxText3) && (
            <Text {...buyBoxText3} cmsHandler={cmsHandler} />
          )}
        </div>

        <div className="buy-actions">
          <Button
            {...buyBoxButton1}
            cmsHandler={cmsHandler}
            taggingInfo={taggingButton1}
          />
          <Button
            {...buyBoxButton2}
            cmsHandler={cmsHandler}
            taggingInfo={taggingButton2}
          />
          <CmsClickToCall {...buyBoxC2C} cmsHandler={cmsHandler} />
        </div>
      </div>
      {/* LEGALES */}
      {hasLegalesText2 || hasLegalesText1 || cmsHandler ? (
        <div className="legal">
          <hr className="separator" aria-hidden="true" />
          {hasLegalesText2 && <Text {...legalesText2} cmsHandler={cmsHandler} />}
          {!cmsHandler && hasLegalesText1 && (
            <CustomLink
              {...legalesLink1}
              alias={alias}
              cmsHandler={cmsHandler}
              taggingInfo={taggingLink1}
            >
              <Text {...legalesText1} cmsHandler={cmsHandler} />
            </CustomLink>
          )}

          {cmsHandler && (
            <div className="edit-legal-gap">
              <CustomLink
                {...legalesLink1}
                cmsHandler={cmsHandler}
                alias={alias}
                taggingInfo={taggingLink1}
              />
              {hasLegalesText1 && (
                <Text {...legalesText1} cmsHandler={cmsHandler} />
              )}
            </div>
          )}
        </div>
      ) : null}
      {showSeparator && <hr className="separator" aria-hidden="true" />}
      <style jsx>{`.buybox-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  .buy-actions {
    display: flex;
    gap: 1rem;
    position: relative;
    :global(.element-editable) {
      position: relative;
    }
  }
  .info-price {
    display: flex;
    gap: 0.5rem;
    flex-direction: column;
    .content-price {
      display: flex;
      gap: 0.5rem;
    }
    :global(div.element-editable) {
      padding: 0;
    }
  }
  @media screen and (max-width: 911px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    .buy-actions {
      width: 100%;
      flex-direction: column;
      :global(.buttonx) {
        width: 100%;
      }
    }
  }
}
.legal {
  width: 100%;
  position: relative;
  hr.separator {
    margin: 1rem 0;
  }
}
`}</style>
    </>
  );
}

export default CmsBuybox;
